import React from 'react';
import styles from './how-to-list.module.scss';

const HowToList = ({ children }) => {
  return <ol className={styles.root}>{children}</ol>;
};

export default HowToList;
